import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.UPDATE_CONFIRMATION_INFO](state, info) {
        state.confirmationModal = info;
    },

    [types.SET_IS_CONFIRM_SHOWN](state, isConfirmShown) {
        state.isConfirmShown = isConfirmShown;
    },

    [types.SET_IS_FADE_SHOWN](state, isFadeShown) {
        isFadeShown
            ? document.body.classList.add('stop-scrolling')
            : document.body.classList.remove('stop-scrolling');

        state.isFadeShown = isFadeShown;
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/confirmModal/mutations.js